import { defineMessages } from "react-intl";
import { LoginStatus } from "../../contract/pam.js";
const localizedLoginStatus = defineMessages({
  [LoginStatus.Success]: {
    id: "logintatusSuccess",
    defaultMessage: "Success"
  },
  [LoginStatus.Failed]: {
    id: "loginStatusFailed",
    defaultMessage: "Failed"
  }
});
export {
  localizedLoginStatus
};
//# sourceMappingURL=loginStatus.js.map
